interface Props {
  label: string
  value: string
  sublabel?: string
}

export default function MetricCard({ label, value, sublabel }: Props) {
  return (
    <div className="bg-slate-50 rounded-xl p-4 border border-dl-border">
      <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{label}</p>
      <p className="mt-1 text-xl font-bold text-gray-900">{value}</p>
      {sublabel && <p className="mt-0.5 text-xs text-slate-400">{sublabel}</p>}
    </div>
  )
}
